import {Point} from "../point";

export class Route {
  visible: boolean = false;
  points: Point[] = [];
  color: string;
}
